import Vue from 'vue'
import store from '@/store/store.js';
import VueResource from 'vue-resource'
Vue.use(VueResource)

import { ApiUtil as api } from "@/utils/api.util.js";

export class AuthService {
  static URL = process.env.API_URL + process.env.API_VER
  static RESOURCE = '/auth/'

  static login(data = {}) {
    return new Promise((resolve, reject) => {
      Vue.http
        .post(this.URL + this.RESOURCE + 'login/', data)
        .then(response => {
          return resolve(response.data)
        })
        .catch(err => {
          // Not sure about this one yet...
          return reject(err)
        })
    })
  }

  static register(data = {}) {
    return new Promise((resolve, reject) => {
      Vue.http
        .post(this.URL + this.RESOURCE + 'register/', data)
        .then(response => {
          return resolve(response.data)
        })
        .catch(err => {
          // Not sure about this one yet...
          return reject(err)
        })
    })
  }

  static logout() {
    return new Promise((resolve, reject) => {
      store.dispatch('Auth/clearToken');
      // clear local storage
      localStorage.clear();
      return resolve(true);
    });
  }

  static tokenExchange(data = {}) {
    return new Promise((resolve, reject) => {
      Vue.http
        .post(this.URL + this.RESOURCE + 'token-exchange/', data)
        .then(response => {
          return resolve(response.data)
        })
        .catch(err => {
          // Not sure about this one yet...
          return reject(err)
        })
    })
  }

  static getUser() {
    return Vue.http.get(
      this.URL + this.RESOURCE + 'user?includes=firm,firm.permissions,firm.attributes,firm.givenContracts.permissions,firm.contracts.permissions,roles,permissions,attributes'
    )
  }

  static getMasterUser(authorization) {
    return Vue.http.get(
      this.URL + this.RESOURCE + 'user?includes=firm,roles,permissions,attributes,master_token'
    )
  }

  static tokenDownload() {
    return Vue.http
      .get(this.URL + this.RESOURCE + 'token-download')
      .then(response => {
        const { token } = response.data

        return token
      })
      .catch(err => {
        // Not sure about this one yet...
        throw err
      })
  }

  static forgotPassword(data) {
    return Vue.http.post(this.URL + this.RESOURCE + 'password/forgot', data)
  }

  static resetPassword(data) {
    return Vue.http.post(this.URL + this.RESOURCE + 'password/reset', data)
  }

  static teleport(data) {
    return Vue.http.post(this.URL + this.RESOURCE + 'teleport', data)
  }

  static setPassword(data) {
    return Vue.http.post(this.URL + this.RESOURCE + 'set-password', data)
  }

  static loginAuth0(data) {
    return Vue.http.post(this.URL + this.RESOURCE + 'login-auth0', data);
  }
}



// WEBPACK FOOTER //
// ./src/services/auth.service.js